/** Root-screen edge gesture; child screens reserve this gesture for back navigation. */
export function attachNativeHomeSwipe(onOpen: () => void, rtl: boolean) {
  let start: { id: number; x: number; y: number; link: HTMLAnchorElement | null } | null = null;
  let swipedLink: HTMLAnchorElement | null = null;
  const cancel = () => { start = null; };

  const onDown = (event: PointerEvent) => {
    cancel();
    swipedLink = null;
    if (event.pointerType !== 'touch' || !event.isPrimary) return;
    const edgeDistance = rtl ? window.innerWidth - event.clientX : event.clientX;
    if (edgeDistance < 0 || edgeDistance > 24) return;
    if (document.querySelector('[aria-modal="true"], [role="dialog"][data-state="open"], [role="alertdialog"], [data-native-menu-open="true"]')) return;
    if (event.target instanceof Element && event.target.closest(
      'button, input, textarea, select, [contenteditable="true"], [role="button"], [role="slider"]',
    )) return;
    start = {
      id: event.pointerId, x: event.clientX, y: event.clientY,
      link: event.target instanceof Element ? event.target.closest('a') : null,
    };
  };

  const onMove = (event: PointerEvent) => {
    if (!start || event.pointerId !== start.id) return;
    const inward = (event.clientX - start.x) * (rtl ? -1 : 1);
    const vertical = Math.abs(event.clientY - start.y);
    if (inward < -10 || (vertical > 10 && vertical > inward)) cancel();
  };

  const onUp = (event: PointerEvent) => {
    if (!start || event.pointerId !== start.id) return;
    const inward = (event.clientX - start.x) * (rtl ? -1 : 1);
    const vertical = Math.abs(event.clientY - start.y);
    const link = start.link;
    cancel();
    if (inward >= 64 && inward > vertical * 1.5) {
      swipedLink = link;
      onOpen();
    }
  };

  // A swipe across the linked home hero must not also follow that link.
  const onClick = (event: MouseEvent) => {
    const link = swipedLink;
    swipedLink = null;
    if (link && event.target instanceof Node && link.contains(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };

  document.addEventListener('click', onClick, true);
  document.addEventListener('pointerdown', onDown, { passive: true });
  document.addEventListener('pointermove', onMove, { passive: true });
  document.addEventListener('pointerup', onUp, { passive: true });
  document.addEventListener('pointercancel', cancel, { passive: true });
  return () => {
    document.removeEventListener('click', onClick, true);
    document.removeEventListener('pointerdown', onDown);
    document.removeEventListener('pointermove', onMove);
    document.removeEventListener('pointerup', onUp);
    document.removeEventListener('pointercancel', cancel);
  };
}
